import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import GLAccountCard from "./Card"
import PropTypes from "prop-types"

class GLAccountDetails extends React.Component {

  componentDidMount() {
    const { params, setCurrentId, loadData } = this.props
    setCurrentId(params.id);
    loadData()
  }

  render() {
    const { glAccount, glAccounts } = this.props;
    return glAccount ? <GLAccountCard glAccount={ glAccount } glAccounts={ glAccounts } />
      : <p>Loading ..</p>
  }
}

GLAccountDetails.propTypes = {
  glAccount: PropTypes.object,
  setCurrentId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const glAccount = DckSelectors.selectItemById(state, ItemTypes.GLAccount, ownProps.params.id)
  const glAccounts = DckSelectors.selectAllItems(state, ItemTypes.GLAccount)
  return { glAccount, glAccounts }
}

const mapDispatchToProps = dispatch => ({
  setCurrentId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.GLAccount, id)),
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLAccount)),
})

export default connect(mapStateToProps, mapDispatchToProps)(GLAccountDetails)



// WEBPACK FOOTER //
// ./src/components/Accounting/GLAccounts/Details.js